<template>
  <div class="RechargeView">
    <RechargeForm
      :min-amount="settings.min_amount_recharge"
      :max-amount="settings.max_amount_recharge"
      :promotions="settings.promotions"
    />
  </div>
</template>

<script>
import RechargeForm from '@/components/Recharge/RechargeForm';

export default {
  name: 'Recharge',

  props: {
    settings: Object,
  },
  components: { RechargeForm },
};
</script>
